module.exports = __webpack_public_path__ + "img/topseller@3x.3e506bca.webp";